'use client';

import { useState } from 'react';
import dynamic from 'next/dynamic';

import { decodeEntityString } from '@libs/algolia';
import { useProductDetails } from '@app/pdp/hooks/useProductDetails';
import ProductAssetsGallery from './components/ProductAssetsGallery';
import './ProductCarousel.scss';

const ProductAssetGalleryModal = dynamic(
    () =>
        import('@app/pdp/components/ProductCarousel/ProductAssetGalleryModal'),
    {
        ssr: false,
    }
);

export default function ProductCarousel() {
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedModalIndex, setSelectedModalIndex] = useState(0);
    const { selectedProduct, product } = useProductDetails();
    const productName = decodeEntityString(product.name);
    const productAssets = product.productAssets[selectedProduct.id];

    const openModal = () => {
        setModalOpen(true);
    };

    const openModalAndSetIndex = (index: number) => {
        openModal();
        setSelectedModalIndex(index);
    };

    if (!productAssets?.length) {
        return null;
    }

    return (
        <>
            <ProductAssetsGallery
                wrapperProps={{
                    maxNumberOfItemsToDisplay: 5,
                    onLastDisplayedItemClick: openModal,
                }}
                openModalAndSetIndex={openModalAndSetIndex}
                productAssets={productAssets}
                productName={productName}
                constrainWidth
            />
            <ProductAssetGalleryModal
                modalOpen={modalOpen}
                closeModal={() => setModalOpen(false)}
                selectedModalIndex={selectedModalIndex}
                productName={productName}
                productAssets={productAssets}
            />
        </>
    );
}
